import React from "react";

import "../../Styles/Question.css";

const QuestionKnowledge = ({
  questionsList,
  questionNumber,
  selectedOption,
  setSelectedOption,
  setQuestionAnswer,
  questionAnswer,
}) => {
  return (
    <ul className="Testpage-inside-bottom-inside-question-ul">
      <li className="Testpage-inside-bottom-inside-question-ul-title">
        <div className="Testpage-inside-bottom-inside-question-ul-title-inside">
          <span className="Testpage-inside-bottom-inside-question-ul-title-inside-number">
            {questionNumber + 1}
          </span>
          <p className="Testpage-inside-bottom-inside-question-ul-title-inside-text">
            {questionsList.question}
          </p>
        </div>
      </li>
      {/* ============================================================= */}

      {questionsList.type === 1 ? (
        questionsList.options.map((item, i) => (
          <li key={item.id}>
            <input
              type="radio"
              hidden
              id={item.id}
              onChange={() => setSelectedOption(item.id)}
              checked={selectedOption == item.id}
              name="answer"
              className="Testpage-inside-bottom-inside-question-ul-Option-input"
              value={item.id}
            />
            <label
              htmlFor={item.id}
              className="Testpage-inside-bottom-inside-question-ul-Option"
            >
              <div className="Testpage-inside-bottom-inside-question-ul-Option-inside">
                <div className="Testpage-inside-bottom-inside-question-ul-Option-inside-circle">
                  <svg height="40" width="40">
                    <circle cx="20" cy="20" r="10" className="circle" />
                  </svg>
                </div>
                <p className="Testpage-inside-bottom-inside-question-ul-Option-inside-text">
                  {item.option}
                </p>
              </div>
            </label>
          </li>
        ))
      ) : (
        <div>
          <textarea
            className="Testpage-inside-bottom-inside-question-input-test"
            placeholder="جواب این سوال رو اینجا بنویس "
            value={questionAnswer}
            onChange={(e) => setQuestionAnswer(e.target.value)}
          />
        </div>
      )}
    </ul>
  );
};
export default QuestionKnowledge;
